import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { fetchCapabilityGroup, updateCapabilityGroupForm } from 'services/capabilityGroups/duck';
import { push } from 'connected-react-router';
import EditForm from 'components/organisms/forms/EditCapabilityGroup';

class EditCapabilityGroupContainer extends Component {
    componentDidMount() {
        const capabilityGroupId = this.props.match.params.id;

        if (this.props.fetchCapabilityGroup && capabilityGroupId) {
            this.props.fetchCapabilityGroup({ capabilityGroupId });
        }
    }

    render() {
        return (
            <EditForm
                capabilityGroup={this.props.capabilityGroup}
                handleSubmit={this.props.handleSubmit.bind(null, updateCapabilityGroupForm)}
                currentUser={this.props.currentUser}
                cancel={() => this.props.push(`/admin/capability-groups/${this.props.match.params.id}`)} >
                {this.props.children}
            </EditForm>
        );
    }
}

const mapStateToProps = state => ({
    capabilityGroup: state.capabilityGroups.capabilityGroup,
    initialValues: state.capabilityGroups.capabilityGroup,
    currentUser: state.users.currentUser
});

export default compose(
    connect(mapStateToProps, { fetchCapabilityGroup, push }),
    reduxForm({
        form: 'editCapabilityGroup',
        enableReinitialize: true,
        initialValues: {
            Capabilities: []
        }
    })
)(EditCapabilityGroupContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/capabilityGroups/EditCapabilityGroupContainer.js